import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { Loader2, CheckCircle2, XCircle, ArrowRight } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function RepriseePaiement() {
  const { transactionId } = useParams();
  const [etat, setEtat] = useState("chargement"); // chargement | accepte | erreur

  useEffect(() => {
    let annule = false;
    (async () => {
      try {
        const r = await axios.post(`${API}/paiements/reprise/${transactionId}`);
        if (annule) return;
        if (r.data.mode === "live" && r.data.payment_url) {
          window.location.assign(r.data.payment_url); // redirection Mobile Money immédiate
          return;
        }
        setEtat("accepte"); // démo ou déjà payé
      } catch {
        if (!annule) setEtat("erreur");
      }
    })();
    return () => { annule = true; };
  }, [transactionId]);

  const vues = {
    chargement: { Icon: Loader2, spin: true, couleur: "#D4AF37", titre: "Reprise de votre paiement…", texte: "Nous vous redirigeons vers le paiement Mobile Money." },
    accepte: { Icon: CheckCircle2, couleur: "#0A5C36", titre: "Abonnement activé !", texte: "Votre paiement est confirmé. Bienvenue !" },
    erreur: { Icon: XCircle, couleur: "#E05638", titre: "Reprise impossible", texte: "Ce lien de paiement n'est plus valable. Relancez l'abonnement." },
  };
  const v = vues[etat];

  return (
    <div className="bg-[#FAF8F5] min-h-screen">
      <Navbar />
      <main className="max-w-lg mx-auto px-4 pt-40 pb-24 text-center" data-testid="paiement-reprise">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-3xl border border-[#E5DFD5] p-10 shadow-sm">
          <v.Icon size={56} className={`mx-auto mb-5 ${v.spin ? "animate-spin" : ""}`} style={{ color: v.couleur }} />
          <h1 className="font-heading text-2xl font-extrabold text-stone-900">{v.titre}</h1>
          <p className="mt-3 text-stone-600">{v.texte}</p>
          <div className="mt-8 flex flex-col gap-3">
            <Link to="/compte" className="inline-flex items-center justify-center gap-2 rounded-full bg-[#12100E] text-white py-3 font-semibold">
              Mon compte <ArrowRight size={16} />
            </Link>
            {etat === "erreur" && (
              <Link to="/abonnement" className="text-sm font-semibold text-[#E05638]">Relancer l'abonnement</Link>
            )}
          </div>
        </motion.div>
      </main>
      <Footer />
    </div>
  );
}
